export class initExternalLib {
    constructor(url) {
        let script = document.createElement('script');
        script.setAttribute('src', url);
        document.head.appendChild(script);
    }

    static withPromise(url) {
        return new Promise(resolve => {
            let script = document.createElement('script');
            script.setAttribute('src', url);
            script.onload = resolve;
            document.head.appendChild(script);
        })
    }
}